var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"small":"","label":"","color":_vm.dataView.color,"text-color":"white"}},[_vm._v("\n  "+_vm._s(_vm.dataView.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }